import data from "../../.sourceflow/team.json";
import BaseCollection from "@sourceflow-uk/sourceflow-sdk/base_collection";

export const getTeam = (locale = "en") => {
  return new BaseCollection(data, locale).orderBy((i) => parseInt(i["_order"])).getItems();
};
